import { IconButton, Theme, Tooltip } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { RegistryTypes } from '../../types/artifacts-type';
import { getRegistryIconType } from '../../utils/artifacts-utils';

const ArtifactRegistryCell: FC<
  React.PropsWithChildren<ArtifactRegistryCellProps>
> = ({ registryType, url }) => {
  const { classes } = useStyles();
  const RegistryIcon = getRegistryIconType(registryType);

  return (
    <Tooltip title={registryType} arrow placement='top'>
      <div className={classes.artifactCodeCell}>
        {RegistryIcon && url && (
          <IconButton
            size='small'
            target='_blank'
            href={url}
            style={{ backgroundColor: 'transparent' }}>
            <RegistryIcon
              className={classes.icon}
              color={registryType === RegistryTypes.JFrog ? '#41BF47' : ''}
            />
          </IconButton>
        )}
      </div>
    </Tooltip>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  artifactCodeCell: {
    display: 'inline-flex',
    gap: theme.spacing(0.5),
    alignItems: 'center',
  },
  icon: {
    width: 'auto',
    height: '1em',
  },
  overflow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    display: '-webkit-box',
    whiteSpace: 'pre-wrap',
    lineClamp: 2,
    WebkitLineClamp: 2,
    lineHeight: 1,
    WebkitBoxOrient: 'vertical',
  },
}));

export interface ArtifactRegistryCellProps {
  registryType: RegistryTypes;
  url: string;
}

export default ArtifactRegistryCell;
